import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useInView } from "framer-motion";
import { Calendar, ArrowRight } from "lucide-react";
import { articles } from "../data/articles";

const AnimatedSection = ({ children, className = "" }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 40 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

const ResourcesPage = () => {
  return (
    <div className="overflow-hidden">
      {/* Hero */}
      <section className="pt-32 pb-16 bg-[#FAF9F6] relative">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 right-0 w-[500px] h-[500px] rounded-full bg-[#C4956A]/5 blur-3xl" />
        </div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="max-w-3xl"
          >
            <span className="text-sm font-semibold uppercase tracking-wider text-[#C4956A]">
              Ressources
            </span>
            <h1 className="text-4xl lg:text-5xl font-bold text-[#1A1A2E] mt-4">
              Nos <span className="text-[#C4956A]">conseils</span> et analyses
            </h1>
            <p className="text-lg text-[#1A1A2E]/60 mt-6 leading-relaxed">
              {"Retrouvez nos articles, guides et analyses pour mieux comprendre l'investissement locatif à Marseille."}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {Array.isArray(articles) ? articles.map((article) => (
              <AnimatedSection key={article.id}>
                <Link
                  to={`/ressources/${article.slug}`}
                  className="group block"
                >
                  <div className="relative h-52 overflow-hidden rounded-xl mb-4">
                    <img
                      src={article.image}
                      alt={article.titre}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-3 py-1 bg-[#C4956A] text-white text-xs font-medium rounded-full">
                        {article.categorie}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-[#1A1A2E]/40 mb-2">
                    <Calendar className="w-3.5 h-3.5" />
                    {article.date}
                  </div>
                  <h3 className="text-lg font-semibold text-[#1A1A2E] group-hover:text-[#C4956A] transition-colors mb-2 leading-tight">
                    {article.titre}
                  </h3>
                  <p className="text-sm text-[#1A1A2E]/60 leading-relaxed">
                    {article.description}
                  </p>
                  <div className="flex items-center gap-1 mt-3 text-sm text-[#C4956A] font-medium">
                    Lire la suite
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </Link>
              </AnimatedSection>
            )) : null}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResourcesPage;
